<template>
  <div class="pages">
    <headers />

    <div class="tabList">
      <ul>
        <li
          :class="checkTab == index?'check':''"
          v-for="(item,index) in projectList"
          :key="index"
          @click="checkTabClick(index)"
        >{{item.name}}</li>
      </ul>
    </div>

    <div class="main">
      <div class="extractPro">
        <p>{{projectList[checkTab].name}}</p>
        <p>
          <span>{{projectList[checkTab].file_total_num}}张</span>
          <span
            v-if="projectList[checkTab].file_total_size < 1024"
          >{{projectList[checkTab].file_total_size}}B</span>
          <span
            v-else-if="1024 <= projectList[checkTab].file_total_size && projectList[checkTab].file_total_size < 1048576"
          >{{(projectList[checkTab].file_total_size / 1024).toFixed(1)}}KB</span>
          <span
            v-else-if="1048576 <= projectList[checkTab].file_total_size && projectList[checkTab].file_total_size < 1073741824"
          >{{(projectList[checkTab].file_total_size/1048576).toFixed(1)}}MB</span>
          <span
            v-else-if="1073741824 <= projectList[checkTab].file_total_size && projectList[checkTab].file_total_size < 1099511627776"
          >{{(projectList[checkTab].file_total_size/1073741824).toFixed(1)}}GB</span>
          <span>{{projectList[checkTab].restDate}}后过期</span>
        </p>
      </div>

      <div class="extractImg">
        <div
          class="extractImgItem"
          v-for="(item,index) in projectList[checkTab].file_list"
          :key="index"
        >
          <div class="quTmd" v-if="item.is_dir == 0">
            <div class="imgView">
              <img
                class="hehe"
                :src="'https://file.zuopin.cloud/' + item.object_key + '?imageMogr2/thumbnail/300x300'"
                alt
              />
              <img
                v-if="item.check == 0"
                src="../../assets/img/imgNoCheck.svg"
                alt
                class="check"
                @click="checkCilck(0,index)"
              />
              <img
                v-if="item.check == 1"
                src="../../assets/img/imgCheck.svg"
                alt
                class="check"
                @click="checkCilck(1,index)"
              />
            </div>
            <p>{{item.name}}</p>
          </div>
        </div>
      </div>

      <div class="saveBtn" @click="saveStatus = true">
        <span v-if="allCheck == 0">保存全部作品</span>
        <span v-else>保存选中作品</span>
      </div>
    </div>

    <!-- 保存弹窗 -->
    <div class="mask" v-if="saveStatus || baiduOatu">
      <div class="saveBottom" v-if="saveStatus">
        <div class="maskClose" style="margin-bottom:30px">
          <p>保存选中作品</p>
          <img src="../../assets/img/stepsClose.svg" alt />
        </div>
        <div class="maskClose" style="margin-bottom:20px" @click="downLoadType(0)">
          <div class="noName">
            <img v-if="saveType == 0" src="../../assets/img/optionsCheck.svg" alt />
            <img v-else src="../../assets/img/optionsNoCheck.svg" alt />
            保存小图至手机
          </div>
          <!-- <div class="noName">17M/约1分钟</div> -->
          <div></div>
        </div>
        <div class="maskClose" @click="downLoadType(1)">
          <div class="noName">
            <img v-if="saveType == 1" src="../../assets/img/optionsCheck.svg" alt />
            <img v-else src="../../assets/img/optionsNoCheck.svg" alt />
            保存原图至电脑
          </div>
          <!-- <div class="noName">17M/约1分钟</div> -->
          <div></div>
        </div>

        <div class="maskClose" @click="downLoadType(2)">
          <div class="noName">
            <img v-if="saveType == 2" src="../../assets/img/optionsCheck.svg" alt />
            <img v-else src="../../assets/img/optionsNoCheck.svg" alt />
            保存原图至百度网盘
          </div>
          <!-- <div class="noName">17M/约1分钟</div> -->
          <div></div>
        </div>

        <div class="saveBtn" @click="saveImmed">立即保存</div>
      </div>

      <div class="saveContent" v-if="baiduOatu">
        <div class="close">
          <img src="../../assets/img/stepsClose.svg" alt />
        </div>
        <div class="saveWangPan">
          <p>该选项需要授权百度网盘</p>
          <p class="subtitle">授权后即可保存原图至网盘</p>
        </div>
        <div class="btnList">
          <div class="closeAuth">关闭</div>
          <div class="immideAuth">立即授权</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "../../components/clientHeader";
import { obtain,downUp } from "@/request/api";

import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  name: "mobileClient",
  components: { headers },
  data() {
    return {
      maskStatus: 0,
      checkTab: 0,
      allCheck: 0,
      saveType: 0,
      saveStatus: false,
      baiduOatu: false,
      loading: {},
      projectList: [
        {
          name: "",
          restDate: "",
          file_total_num: 0,
          file_total_size: 0,
          file_list: []
        }
      ],
      allImgArr: []
    };
  },
  methods: {
    closeSwiper() {
      this.maskStatus = 0;
    },
    _isMobile() {
      const flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    // 头部切换
    checkTabClick(index) {
      this.checkTab = index;
      // 切换的时候，要把图片选中的文件清空
      let { projectList } = this;
      projectList[index].file_list.forEach(element => {
        element.check = 0;
      });
      this.allCheck = 0;
    },
    // 获取列表
    getProList() {
      var that = this;
      var code = this.$route.query.id;
      console.log(code);
      obtain({ code: code }).then(res => {
        let dataDeal = res.data.data;
        dataDeal.forEach(element => {
          // 处理剩余时间
          let startTime = new Date();
          let endTime = new Date(element.expired_at);
          let restDate = endTime - startTime;
          if (restDate / (1000 * 60 * 60 * 24) >= 1) {
            element.restDate =
              (restDate / (1000 * 60 * 60 * 24)).toFixed(0) + "天";
          } else if (restDate / (1000 * 60 * 60) >= 1) {
            element.restDate =
              (restDate / (1000 * 60 * 60)).toFixed(0) + "小时";
          } else {
            element.restDate = (restDate / (1000 * 60)).toFixed(0) + "分";
          }

          // 处理选中
          element.file_list.forEach(item => {
            item.check = 0;
          });
        });
        console.log(dataDeal);
        this.projectList = dataDeal;
      });
    },

    // 处理图片选中的状态
    checkCilck(status, index) {
      var that = this;
      let { projectList, checkTab } = this;
      projectList[checkTab].file_list.forEach((element, idx) => {
        if (idx == index) {
          if (status == 0) {
            element.check = 1;
          } else {
            element.check = 0;
          }
        }
      });

      let checkImg = projectList[checkTab].file_list.filter(element => {
        if (element.check == 1) {
          return element;
        }
      });

      if (checkImg.length == 0) {
        that.allCheck = 0;
      } else {
        that.allCheck = 1;
      }
    },

    //
    downLoadType(index) {
      this.saveType = index;
    },

    //loading

    saveImed(){
      var that = this
      let { allCheck,saveType, } = this


      allCheck == 0?saveAll():savePart()


    },

    // --------------------------------------------下载----------------------------------------------

    // 保存全部
    saveAll() {
      var that = this;
      let { projectList, checkTab, saveType } = this;
      console.log("1111");
      let allImgArr = [];
      console.log(projectList[checkTab]);
      let arr = projectList[checkTab].file_list;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].is_dir == 0) {
          // 小图
          if (saveType == 0) {
            console.log(saveType, "???? 小图");
            allImgArr.push({
              fileUrl:
                "https://file.zuopin.cloud/" +
                arr[i].object_key +
                "?imageMogr2/thumbnail/600x600",
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          } else if (saveType == 1) {
            console.log(saveType, "???? 原图");
            // 原图
            allImgArr.push({
              fileUrl: "https://file.zuopin.cloud/" + arr[i].object_key,
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          }
        }
      }
      that.filesToRar(allImgArr, projectList[checkTab].name);

      this.loading = this.$loading({
        lock: true,
        text: "正在打包保存中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.saveStatus = false;
    },

    // 保存选中
    savePart() {
      var that = this;
      let { projectList, checkTab, saveType } = this;
      console.log("222222222");
      let allImgArr = [];
      let arr = projectList[checkTab].file_list;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].is_dir == 0 && arr[i].check == 1) {
          // 小图
          if (saveType == 0) {
            console.log(saveType, "???? 小图");
            allImgArr.push({
              fileUrl:
                "https://file.zuopin.cloud/" +
                arr[i].object_key +
                "?imageMogr2/thumbnail/300x300",
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          } else {
            console.log(saveType, "???? 原图");
            // 原图
            allImgArr.push({
              fileUrl: "https://file.zuopin.cloud/" + arr[i].object_key,
              renameFileName: arr[i].name + "." + arr[i].extension
            });
          }
        }
      }

      this.loading = this.$loading({
        lock: true,
        text: "正在打包保存中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.saveStatus = false;
      that.filesToRar(allImgArr, projectList[checkTab].name);
    },

    filesToRar(arrImages, filename) {
      let _this = this;
      let zip = new JSZip();
      let cache = {};
      let promises = [];
      _this.title = "正在加载压缩文件";

      for (let item of arrImages) {
        const promise = _this.getImgArrayBuffer(item.fileUrl).then(data => {
          // 下载文件, 并存成ArrayBuffer对象(blob)
          zip.file(item.renameFileName, data, { binary: true }); // 逐个添加文件
          cache[item.renameFileName] = data;
        });
        promises.push(promise);
      }

      Promise.all(promises)
        .then(() => {
          zip.generateAsync({ type: "blob" }).then(content => {
            _this.title = "正在压缩";
            // 生成二进制流
            FileSaver.saveAs(content, filename); // 利用file-saver保存文件  自定义文件名
            _this.title = "压缩完成";
            _this.loading.close();
              let params = {
              obtain_code:_this.$route.query.id
            }
            downUp().then(res=>{
              console.log(res,'下载次数')
            })

          });
        })
        .catch(res => {
          _this.$message.error("文件压缩失败");
        });
    },
    //获取文件blob
    getImgArrayBuffer(url) {
      let _this = this;
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function() {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },

    // 百度授权
    


  },
  mounted() {
    this.getProList();
  }
};
</script>

<style lang="less" scoped>
.main {
  width: 83%;
  margin: auto;

  .extractPro {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      span {
        margin-left: 14px;
      }
    }
  }

  .extractImg {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 50px;
    .extractImgItem {
      margin-top: 30px;
      .quTmd {
        width: 93px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 8px;
        .imgView {
          width: 93px;
          height: 93px;
          border-radius: 10px;
          position: relative;
          .hehe {
            width: 93px;
            height: 93px;
            border-radius: 10px;
            object-fit: cover;
          }
          .check {
            position: absolute;
            right: 8px;
            top: 8px;
            width: 16px;
            height: 16px;
          }
        }
        p {
          width: 93px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          margin-top: 14px;
        }
      }
    }
  }

  .saveBtn {
    width: 160px;
    height:44px;
    margin: 0 auto 30px;
    text-align: center;
    line-height: 44px;
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    background: #000;
  }
}

.tabList {
  overflow-x: scroll;
  padding-left: 35px;
  margin: 40px 0px 30px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  ul {
    list-style: none;
    white-space: nowrap;
    li {
      // float: left;
      display: inline-block;
      border-radius: 18px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      height: 32px;
      line-height: 32px;
      padding: 0px 15px;
    }
    .check {
      background: rgba(0, 0, 0, 1);
      color: rgba(255, 255, 255, 1);
    }
  }
}

.mask {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  .saveBottom {
    width: 355px;
    background: #ffffff;
    border-radius: 20px;
    position: absolute;
    bottom: 20px;
    left: 50%;
    margin-left: -177px;
    padding: 15px 20px;
    box-sizing: border-box;
    .maskClose {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 40px;
      .noName {
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        img {
          vertical-align: middle;
        }
      }
    }
    .saveBtn {
      width: 160px;
      height: 44px;
      background: rgba(0, 0, 0, 1);
      border-radius: 22px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      text-align: center;
      line-height: 44px;
      margin: auto;
    }
  }
  .saveContent {
    width: 336px;
    background: #ffffff;
    height:199px;
    border-radius: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: 168px;
    margin-top: -99px;
    padding: 15px 20px;
    box-sizing: border-box;
    .close {
      text-align: right;
    }
    .saveWangPan {
      font-size: 17px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      text-align: center;
      margin-top:23px;
      .subtitle {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        margin: 10px 0px 30px;
      }
    }
    .btnList {
      width: 85%;
      margin: auto;
      display: flex;
      justify-content: space-around;
      div {
        width: 110px;
        height: 40px;
        border-radius: 40px;
        text-align: center;
        line-height:40px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
      }
      .immideAuth {
        background: rgba(0, 0, 0, 1);
        color: #ffffff;
      }
      .closeAuth {
        background: rgba(240, 240, 240, 1);
        color: #000000;
      }
    }
  }
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  background-color: rgba(240, 240, 240, 0);
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  box-shadow: inset000pxrgba(240, 240, 240, 0);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 0);
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0);
  box-shadow: inset000pxrgba(240, 240, 240, 0);
}
</style>